export const ACTIVE_TIMESTAMP_MARKER_Z_INDEX = 1;
